export default {
  haulers: 'Dumper',
  setup: 'Uppstart',
  driverExperience: 'Förarerfarenhet',
  users: 'Användare',
};
